<template>
  <div>
    
    
    
    <a-card :bordered="false" class="header-solid h-full mb-20" :bodyStyle="{ paddingTop: '12px' }">
      <template #title>
        <h6>PRINTING BOOKING CALENDAR</h6>
        <p class="mb-10">The calendar shows a list of printing booking.</p>
        <a-tag color="#3D8361" style="font-weight: 200"><a-icon type="pushpin" class="mr-10" />My Booking</a-tag>
        <a-tag color="#6F38C5" style="font-weight: 200"><a-icon type="pushpin" class="mr-10" />Others Booking</a-tag>
        
      </template>

      <a-spin :spinning="!isCalendarLoaded" size="large">
        <a-calendar :header-render="headerRender" @panelChange="onPanelChange" @select="onSelect" fullscreen
          class="small">
          <ul slot="dateCellRender" slot-scope="value" class="events">
            <li v-for="item in getListData(value)" :key="item.keyID">
              <span style="font-size: 14px; font-weight: 700" class="font-weight-bold font-web mt-0 mb-0">
                <a-avatar :size="15" :style="$store.state.role.RulesUser.codeId === item.staffRequestID ? 'background-color:#3D8361' :
                    'background-color:#6F38C5'
                  " icon="pushpin" />
                {{ item.content }}
              </span>
            </li>
          </ul>
        </a-calendar>
      </a-spin>

    </a-card>
  </div>
</template>

<script>
import { calendarMixin } from "@/mixins/calendarMixin";
export default {
  mixins: [calendarMixin],

  data() {
    return {
    };
  },
  methods: {},
};
</script>

<style lang="css" scoped>
.box-loading {
  max-height: max-content;
}

.div-isLoaded {
  text-align: center;
  border-radius: 4px;
  padding: 30px 50px;
  margin: 20px 0;
}

.events {
  list-style: none;
  margin: 0;
  padding: 0;
}

.events .ant-badge-status {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
}

.notes-month {
  text-align: center;
  font-size: 28px;
}

.notes-month section {
  font-size: 28px;
}


@media screen and (max-width: 600px) {
  .small {
    zoom: 65% !important;
  }
}
</style>